<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>İşlem Bekleyen Notlar</h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">Notlar</a></li>
          </ul>
        </div>
  
        <div class="row">
          <div class="col-md-12">
            <div class="tile">
              <div class="tile-body">
                <table class="table table-hover table-bordered" id="sampleTable">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Dosya Adı</th>
                      <th>Dosya Açıklaması</th>
                      <th>Sınıf</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: {
          id: "",
          filename: "",
          filecontent: "",
          class: "",
          imgSrc: "",
          imgUrl: "",
        },
        file: "",
        fileWarn: "",
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      var admin_token = localStorage.getItem("admin_token");
      if(!admin_token){
        this.$router.push("/");
      }
      var results = this.result;
      let datas = [];
  
      let url = store.state.base_url + "Admin/getAllNotes.php?key=123";
      var datas2 = {
        id: localStorage.getItem("id"),
        admin_token: localStorage.getItem("admin_token"),
        sectionsId: localStorage.getItem("sectionsId"),
      };
  
      axios
        .post(url, JSON.stringify(datas2))
        .then((response) => {
            if(response.data.data == false) {
                this.$swal({
                text: "İşlem bekleyen not bulunmamakta!",
                icon: "error",
                closeOnClickOutside: false,
              });  
            }
          datas2 = response.data.data;
          var table = $("#sampleTable").DataTable();
          $.each(datas2, function(index, value) {
            table.row
              .add([
                value["id"],
                value["filename"],
                value["filecontent"],
                value["class"],
              ])
              .draw(false);
          });
  
          $("#sampleTable tbody").on("click", "tr", function() {
            var data = table.row(this).data();
            results.id = data[0];
            window.location.href = "#/notesDetail?id=" + results.id;
          });
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
  
    methods: {
      goProducts: function() {
        console.log("deneme");
        this.router.push(["/staff_detail"], {
          queryParams: { new_id: this.result.id },
        });
        console.log(this.results.id);
      },
    },
  
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/FileConfirmation.vue